import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, NgZone } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';
import { MapsAPILoader } from '@agm/core';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-common-scope',
  templateUrl: './common-scope.component.html',
  styleUrls: ['./common-scope.component.scss']
})
export class CommonScopeComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() buyerId: number;
  @Input() isedit: boolean;
  @Input() displaycomname: string;
  @Input() formone: Array<any>;
  @Input() isInternalEditable: boolean;
  commonObject: any = {
    project_name: null,
    sub_category_position: null
  };
  commonFormOne: Array<any>;
  service_category_name: string;
  serviceCategories: Array<any> = [];
  isEditable: boolean;
  categoryId: number;
  displaycomponentName: string;
  typeOfModule: Array<any> = [];
  commonmultiSelect: any = {};
  buyer_id: number;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  @ViewChild('kitchenFitstStep') firstformValidation: NgForm;
  isAddreesInvalid: boolean;
  // Internal Project
  isInternalProject: boolean;
  subcategorylist_internal: Array<any> = [];
  commonListObject: any = {
    formone: [],
    formtwo: [],
    questionset: []

  };
  constructor(private sellerService: SellerApiService, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone) {

  }

  ngOnInit() {
    // this.loadServiceCategories();
  }

  // Load All the Service categories
  loadServiceCategories() {
    this.sellerService.getServiceCategories().subscribe(response => {
      this.serviceCategories = response;
      if (this.categoryId != null || this.categoryId !== undefined) {
        this.service_category_name = this.getServiceCategoryName(this.categoryId);
      }
    }, err => {
      console.log(err);
    });
  }

  getSubCategoryProjectType(index) {
    if (index != null && index !== 0) {
      // tslint:disable-next-line:prefer-const
      let subcategorylist: Array<any> = [];
      if (this.categoryId != null || this.categoryId !== undefined) {
        subcategorylist = this.sellerService.getSubCategoryType(this.categoryId.toString());
        return subcategorylist[Number(index - 1)];
      }
    }
    return '';
  }


  getSubCategoryInternalProject(categoryId) {
    if (categoryId != null || categoryId !== undefined) {
    this.subcategorylist_internal = this.sellerService.getSubCategoryType(categoryId.toString());
      setTimeout(() => {
        this.loadAddressComponent();
      }, 2000);
    }
  }

  // On sub category change
  onChangeSubCategory(value) {
    if (value != null) {
      this.sellerService.getGeneralizedQuestionSet(this.categoryId, value).pipe(finalize(() => {
      })).subscribe(response => {
        this.commonListObject = JSON.parse(response.question_set);
        this.commonFormOne = this.commonListObject.formone;
        this.commonListObject.formtwo.map((item) => {
          if (item.type === 'multiselect') {
            // this.commonmultiSelectOptions[item.modal] = this.getCommonMultiSelectArray(item.value);
          }
        });

        setTimeout(() => {
          this.loadAddressComponent();
        }, 2000);

      }, err => {
        console.log(err);
      });
    }
  }

  getkitchenProjectType(index) {
    // tslint:disable-next-line:prefer-const
    let kitchenProjects: Array<any> = [];
    kitchenProjects = ['', 'Bygga nytt kök från grunden',
      'Delvis renovering av befintligt kök', 'Totalrenovering av befintligt kök'];
    return kitchenProjects[Number(index)];
  }


  ngOnChanges(changes: SimpleChanges) {
    this.commonFormOne = this.formone;
    this.isEditable = this.isedit;
    this.buyer_id = this.buyerId;
    this.displaycomponentName = this.displaycomname;
    this.isInternalProject = this.isInternalEditable;
    if (this.data != null || this.data !== undefined) {
      this.commonObject = this.data;
      this.categoryId = this.data.service_category_id;
      this.service_category_name = this.data.service_category_name;
      if (this.isInternalProject) {
        this.getSubCategoryInternalProject(this.categoryId);
        window.scrollTo(0, 0);
      }
    }

    // setTimeout(() => {
    //   this.loadAddressComponent();
    // }, 2000);

  }

    // get Category Name
    getServiceCategoryName(index) {
      // tslint:disable-next-line:prefer-const
      let cate = this.serviceCategories.filter(item => item.service_category_id === Number(index));
      if (cate.length > 0) {
        return cate[0].service_category_name;
      } else {
        return '';
      }
    }

  // Remove First Value From Dropdown
  getDropdownList(items: Array<any>, defaultvalue): Array<any> {
    items.map((item, index) => {
      if (item === defaultvalue) {
        items.splice(index, 1);
      }
    });
    return items;
  }

  getValues(position, values) {
    if (this.commonObject[position] != null) {
      return values[Number(this.commonObject[position])];
    }
    return '';
  }

  loadAddressComponent() {

    if (this.searchElementRef) {
      // load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        // tslint:disable-next-line:prefer-const
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ['address'], componentRestrictions: { country: 'SE' }
        });

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            // tslint:disable-next-line:prefer-const
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            // verify result
            if (place.geometry === undefined || place.geometry === null) {
              this.isAddreesInvalid = true;
              return;
            }

            this.commonObject.scope_street_name = place.formatted_address;
            // set latitude, longitude and zoom
            this.commonObject.lat = place.geometry.location.lat();
            this.commonObject.lon = place.geometry.location.lng();
            this.isAddreesInvalid = false;
            // this.zoom = 12;
          });
        });
      });
    }

  }


  // Address validare
  onaddressValidateGoogle() {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      // tslint:disable-next-line:prefer-const
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address'], componentRestrictions: { country: 'SE' }
      });
      this.commonObject.lat = null;
      this.commonObject.lon = null;
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          // tslint:disable-next-line:prefer-const
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            this.isAddreesInvalid = true;
            return;
          }

          this.commonObject.scope_street_name = place.formatted_address;
          // set latitude, longitude and zoom
          this.commonObject.lat = place.geometry.location.lat();
          this.commonObject.lon = place.geometry.location.lng();
          this.isAddreesInvalid = false;
          // this.zoom = 12;
          return;
        });
      });
    });
  }

  callValidationScope(): boolean {
    if (this.firstformValidation.invalid) {
      return false;
    }
    return true;
  }




}





// WEBPACK FOOTER //
// ./src/app/seller/sub-component/common/common-scope/common-scope.component.ts